<template>
	<div class="webContent flex">
		<div class="model">
			<div class="area df hao jcb">
				<div class="name">{{name ? replaceStr(name) : ''}}</div>
				<div class="ask" @click="toRelease">
					发布问题
				</div>
			</div>
			<div class="search df hao">
				<input type="text" puc class="flex" placeholder="本版块搜索" v-model="keyword" />
				<div class="btn" @click="search"></div>
			</div>
			<div class="mode-con">
				<div class="moderator">
					<span class="mode-title">版主1</span>
					<span class="mode-name">{{moderator}}</span>
				</div>
				<div class="moderator" style="margin-left: 0.1rem">
					<span class="mode-title">版主2</span>
					<span class="mode-name">{{deputyModerator}}</span>
				</div>
			</div>
			<div class="scroll" @scroll="listenScroll">
				<div class="list">
					<div class="li" v-for="(v,i) in list" :key="i" @click="toDetail(v)">
						<div class="title"><i v-if="v.announcement==1" class="rule"></i><i v-if="v.refining==1" class="prize"></i><i v-if="v.top==1" class="top"></i><div v-html="v.title">{{v.title}}</div></div>
						<div class="tool df">
							<div class="flex">{{v.answerTotal>0?v.answerTotal+'人回答':'暂无回答'}} · {{v.attentionTotal>0?v.attentionTotal+'人关注':'暂无关注'}}</div>
							<div><b>{{v.creatorName||''}}（{{v.creatorMapperNumber}}）</b>{{dateTime(v.createTime)}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import h5PublicApi from '../../../script/public.js'

	export default {
		name: 'model_list_page',
		data () {
			return {
				mid: '',
				name: '',
				keyword: '',
				pagenum: 1,
				pagesize: 10,
				state: false,
				list: [],
				moderator: '',
				deputyModerator: '',
			}
		},
		mounted(){
			this.mid = this.$route.query.id;
			this.name = this.$route.query.name;

			this.getList();
			this.getModerator()
		},
		methods: {
			replaceStr(input){
				return input.replace('<br/>','');
			},
			getModerator(){
				this.h5Ajax("get", `$/category/selectModerator/${this.mid}`, false).then( res => {
					if(res){
						this.moderator = (res.moderatorUserName ? res.moderatorUserName : '--') +
							(res.moderatorUserMapperNumber ? ' (' + res.moderatorUserMapperNumber +')' : '');
						this.deputyModerator = (res.deputyModeratorUserName ? res.deputyModeratorUserName : '--') + 
							(res.deputyModeratorUserMapperNumber ? ' (' + res.deputyModeratorUserMapperNumber +')' : '');
					}
				})
			},
			dateTime(timestamp){
				if(!timestamp){ return ''; }
				var date = new Date(timestamp);
				var year = date.getFullYear();
				var month = date.getMonth()+1;
				var day = date.getDate();
				month = (month<10?'0':'')+month;
				day = (day<10?'0':'')+day;
				return year+'-'+month+'-'+day;
			},
			listenScroll(e) {  //监听滚动
				let ele = e.srcElement ? e.srcElement : e.target;
				if(ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100){
					this.addMoreData();
				}
			},
			addMoreData() { //加载更多
				if(this.state){
					return false;
				}
				this.pagenum ++;
				this.getList();
			},
			search(){
				this.pagenum = 1;
				this.state = false;
				this.list = [];
				this.getList();
			},
			getList(){
				this.state = true;

				// 获取分类列表版块信息
				this.h5Ajax('get','$/questions/'+(this.keyword==''?'listPage':'searchListPage'),{
					keyword: this.keyword,
					page: this.pagenum,
					categoryId: this.mid,
					size: this.pagesize,
				}).then(r=>{
					if(r.content.length>0){
						for(var i in r.content){
							var d = r.content[i];
							this.list.push(d)
						}
						this.state = false;
					}
				}).catch(err => {
					console.error('err:' + err)
				})
			},
			toRelease(){
				h5PublicApi.checkCanHandle(r=>{
					this.$router.replace({ path: '/model/release', query: { id: this.mid, name: this.name } });
				})
			},
			toDetail(data){
				this.$router.replace({ path: '/model/detail', query: { id: data.id } });
			},
		},
	}
</script>

<style scoped>
	@import './list';
</style>



// WEBPACK FOOTER //
// src/app/pages/model/list/list.vue